export const propertyWidth = {
  xxs: "tw-w-5",
  xs: "tw-w-7",
  sm: "tw-w-10",
};

export const propertyHeight = {};
